function mainSlider() {
  const $slider = $('.home_slider');
  const $slides = $('.home_slider__slide');
  const autoplay_speed = 5000;

  $slides.each(function (index, el) {
    const slide = $(el);
    slide
      .append(html_slide_content({
        // small: slide.data('small'),
        big: slide.data('big'),
        place: slide.data('place')
      }), html_slide_thumb({
        img: slide.data('img'),
        link: slide.data('link'),
        // small: slide.data('small'),
        big: slide.data('big'),
        place: slide.data('place')
      }));
  });

  $slider
    .on('init', function (slick) {
      $('.lds-ellipsis').fadeOut(150);
    })
    .slick({
      rows: 0,
      dots: true,
      autoplay: true,
      draggable: false,
      prevArrow: prevArrow('arrow-right'),
      nextArrow: nextArrow('arrow-right'),
      pauseOnHover: false,
      autoplaySpeed: autoplay_speed,
      speed: 1100,
      adaptiveHeight: true,
      cssEase: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
    })
    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      // switch previews in mobile view
      $('.slider_next').slick('slickGoTo', nextSlide + 1);


      // slider content animation
      if (nextSlide === 0) {
        $slider.slick('slickSetOption', 'speed', 1360, false);
      } else {
        $slider.slick('slickSetOption', 'speed', 1100, false);
      }

      var next_slide = slick.$slides.filter('.slick-current').next();
      var content_small = next_slide.find('.slider_content__small');
      var content_big = next_slide.find('.slider_content__big');
      var content_place = next_slide.find('.slider_content__place');

      TweenMax.from(content_small, 1.2, {
        x: '20%',
        opacity: 0,
        ease: Power2.easeOut
      });
      TweenMax.from(content_big, 1.3, {
        x: '20%',
        delay: 0.1,
        opacity: 0,
        ease: Power2.easeOut
      });
      TweenMax.from(content_place, 1.25, {
        x: '20%',
        delay: 0.2,
        opacity: 0,
        ease: Power2.easeOut
      });

      // slider preview animation
      var preview = next_slide.next().find('.slider_preview');

      TweenMax.from(preview, 1.2, {
        x: '100%',
        delay: 0.3,
        ease: Power2.easeOut
      });
    });
}
